import type { ZodError } from 'zod';

export interface FormattedErrors {
  [key: string | number]: string[] | FormattedErrors;
}

const setNestedValue = (obj: FormattedErrors, path: (string | number)[], value: unknown) => {
  const [head, ...tail] = path;

  if (tail.length === 0) {
    if (!obj[head]) {
      obj[head] = [];
    }
    // @ts-expect-error No idea how to type this
    obj[head].push(value);
    return;
  }

  if (!obj[head]) {
    obj[head] = {};
  }

  setNestedValue(obj[head] as FormattedErrors, tail, value);
};

export const formatZodErrors = (error: ZodError): FormattedErrors => {
  const formattedErrors: FormattedErrors = {};

  error.issues.forEach((issue) => {
    setNestedValue(formattedErrors, issue.path, issue.message);
  });

  return formattedErrors;
};
